export default class MetadataHelper {
  static resolveMetadataField(dataField) {
    return dataField + '_metadata';
  }

  static resolveFlagContentField(dataField) {
    return dataField + '_flagContent';
  }
}